import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';

import unsuccessAnimation from '../../../../assets/images/payment/unsuccess.json';
import Button from 'Components/Globals/Elements/Button/loadable';
import routes from 'Pages/router/constants/routes';
import { composeClassNames } from 'Helpers';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

const UnSuccess = ({ error }) => {
	const { formatMessage } = useContent();
	const navigate = useNavigate();
	return (
		<div className={composeClassNames(['p-16', styles.unsuccess])}>
			<div className={styles.unsuccess__content}>
				<Lottie
					animationData={unsuccessAnimation}
					loop={true}
					style={{ height: '140px' }}
				/>
				<div className={styles.unsuccess__status_wrapper}>
					<div
						className={composeClassNames([
							'p-16 mt-24',
							styles.unsuccess__message_wrapper,
						])}
					>
						<p className='line-height-24 sm bold txt-error-dark'>
							{formatMessage(strings.statusDescription)}
							<br />
							{error}
						</p>
					</div>
					<div
						className={composeClassNames([
							'ph-16',
							styles.unsuccess__description_wrapper,
						])}
					>
						<p className='line-height-24 sm txt-dark'>
							{formatMessage(strings.description)}
						</p>
					</div>
				</div>
			</div>
			<div className={styles.unsuccess__button_wrapper}>
				<Button
					label={formatMessage(strings.backButton)}
					onClick={() => navigate(routes.dashboard)}
					block
					variant='outline'
					className={styles.unsuccess__button}
					color='neutral-gray'
				/>
				<Button
					label={formatMessage(strings.tryAgainButton)}
					onClick={() => navigate(routes.factorAmount)}
					block
					variant='fill'
					className={styles.unsuccess__button}
				/>
			</div>
		</div>
	);
};

UnSuccess.propTypes = {
	error: PropTypes.string,
};

export default UnSuccess;
